export const environment = {
  production: true,
  api: 'https://api.hr.baltecmarine.pl',
  dateFormat: 'YYYY-MM-DD',
};
